import { t, Trans } from '@lingui/macro';
import { EditBookingPermissions } from 'noddi-types';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiChip, NoddiLink, useIsWithinTailWindBreakpoint } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import EditComment from './EditComment';

type Props = {
  slug: string;
  isPaid?: boolean;
  isCancelled?: boolean;
  address: string;
  dataText: string;
  commentsUser: string;
  bookingId: string;
  editBookingPermissions: EditBookingPermissions;
};

export function MetaSection({
  isCancelled,
  isPaid,
  slug,
  address,
  dataText,
  commentsUser,
  bookingId,
  editBookingPermissions
}: Props) {
  const { canEditAddress, canEditComments, timeWindows } = editBookingPermissions;
  const isSm = useIsWithinTailWindBreakpoint('sm');
  return (
    <div className='flex flex-col gap-2'>
      {isCancelled && (
        <div>
          <NoddiChip label={t`Canceled`} variant='destructive' />
        </div>
      )}
      {isPaid && (
        <div>
          <NoddiChip label={t`Paid`} variant='success' />
        </div>
      )}
      <div className='flex justify-between gap-4'>
        <div className='flex gap-2'>
          <NoddiIcon name='LocationPin' size='medium' />
          <p>{address}</p>
        </div>
        {canEditAddress && (
          <NoddiLink
            to={customerRoutes.editBookingAddress.getPath({ id: bookingId })}
            variant='secondary'
            size='small'
            startIcon='Edit'
          >
            {isSm ? <Trans>Edit</Trans> : <Trans>Edit address</Trans>}
          </NoddiLink>
        )}
      </div>

      <div className='flex justify-between gap-4'>
        <div className='flex gap-2'>
          <NoddiIcon name='Calendar' size='medium' />
          <p>{dataText}</p>
        </div>
        {timeWindows.canEdit && (
          <NoddiLink
            to={customerRoutes.editMyBookingTimeWindow.getPath({ id: bookingId })}
            variant='secondary'
            size='small'
            startIcon='Edit'
          >
            {isSm ? <Trans>Edit</Trans> : <Trans>Edit time</Trans>}
          </NoddiLink>
        )}
      </div>
      <div className='flex gap-2'>
        <NoddiIcon size='medium' name='Magnifier' />
        <p>{t`Booking reference : ${slug}`}</p>
      </div>
      {canEditComments && <EditComment commentsUser={commentsUser} bookingId={bookingId} />}
    </div>
  );
}
